module.exports = __webpack_public_path__ + "img/auth_bg.7c3cafaf.png";